/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface WorkflowItem { 
    id?: string;
    description?: string;
    code?: string;
    workflow_id?: string;
    created_at?: Date;
    created_by?: string;
    modified_at?: Date;
    modified_by?: string;
    status_id?: string;
    current_activity_id?: string;
    hashtag?: string;
    callback?: string;
    wait_for_approve?: boolean;
    representative?: string;
}